<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统日志</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <!-- <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">日志列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item>
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入账号名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card> -->
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="module" label="模块" align="center">
          </el-table-column>
          <el-table-column prop="name" label="日志名称" align="center">
          </el-table-column>
          <el-table-column prop="creatorName" label="操作者" align="center">
          </el-table-column>
          <el-table-column label="调用方法" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.method }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="操作时间"
            align="center"
            width="180"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      ruleList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    resetForm() {
      this.ruleForm.name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$axios
        .post(`/admapi/sys/logs/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped></style>
